// ///////////////////////////////////////////////////////////
// tbGraphics: The engine part dealing with graphics
//
// Copyright 2013-2015 CoolGames
// Last Changed: 28-06-2015
// ///////////////////////////////////////////////////////////
import { PIXI } from "./tbPIXI";
import { tbContainer } from "./tbContainer";
import { tbVector } from "./tbVector";
import { mainContainer } from "./tbMainContainer";
var TBGraphics = /** @class */ (function () {
    function TBGraphics() {
        this.canvasCollection = [];
        this.gl = null;
        this.webGLAvailable = false;
        this.mainContainer = mainContainer; // PIXI Container
    }
    // Set the current canvas by id
    TBGraphics.prototype.setCanvasId = function (id) {
        this.canvas = document.getElementById(id);
        this.setCanvas(this.canvas);
    };
    // Set the current canvas
    TBGraphics.prototype.setCanvas = function (canvas) {
        if (this.webGLAvailable) {
            this.canvas = canvas;
            this.context = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
            this.fontContext = this.fontCanvas.getContext("2d");
            this.width = canvas.width;
            this.height = canvas.height;
        }
        else {
            this.canvas = canvas;
            this.context = canvas.getContext("2d");
            this.fontContext = this.context;
            this.width = canvas.width;
            this.height = canvas.height;
        }
    };
    // Clear the current canvas to transparent
    TBGraphics.prototype.clear = function () {
        if (!this.webGLAvailable) {
            this.context.clearRect(0, 0, this.width, this.height);
        }
    };
    // Clear the current canvas to the indicated color
    TBGraphics.prototype.clearColor = function (color) {
        if (!this.webGLAvailable) {
            var oldColor = this.context.fillStyle;
            this.context.fillStyle = color;
            this.context.fillRect(0, 0, this.width, this.height);
            this.context.fillStyle = oldColor;
        }
    };
    // Draw a rectangle
    TBGraphics.prototype.drawRectangle = function (x, y, width, height, fillColor, strokeColor, lineThickness, alpha) {
        if (alpha === void 0) { alpha = 1; }
        var rectangle = new PIXI["Graphics"]();
        if (fillColor) {
            rectangle["beginFill"](fillColor);
        }
        if (strokeColor) {
            lineThickness = lineThickness ? lineThickness : 1;
            rectangle["lineStyle"](lineThickness, strokeColor, 1);
        }
        rectangle["drawRect"](0, 0, width, height);
        rectangle["endFill"]();
        rectangle["x"] = x ? x : 0;
        rectangle["y"] = y ? y : 0;
        rectangle["alpha"] = alpha;
        return rectangle;
    };
    // Draw a rounded rectangle
    TBGraphics.prototype.drawRoundedRectangle = function (x, y, w, h, r, fillColor, strokeColor, lineThickness, alpha) {
        var roundedRectangle = new PIXI["Graphics"]();
        if (fillColor) {
            roundedRectangle["beginFill"](fillColor);
        }
        if (strokeColor) {
            lineThickness = lineThickness ? lineThickness : 1;
            roundedRectangle["lineStyle"](lineThickness, strokeColor, 1);
        }
        roundedRectangle["drawRoundedRect"](0, 0, w, h, r);
        roundedRectangle["endFill"]();
        roundedRectangle["x"] = x ? x : 0;
        roundedRectangle["y"] = y ? y : 0;
        roundedRectangle["alpha"] = alpha !== undefined ? alpha : 1;
        return roundedRectangle;
    };
    // Draw a disk
    TBGraphics.prototype.drawDisk = function (x, y, radius, fillColor, strokeColor, strokeWidth) {
        var circle = new PIXI["Graphics"]();
        if (fillColor) {
            circle["beginFill"](fillColor);
        }
        if (strokeColor) {
            strokeWidth = strokeWidth ? strokeWidth : 1;
            circle["lineStyle"](strokeWidth, strokeColor, 1);
        }
        circle["drawCircle"](0, 0, radius);
        circle["endFill"]();
        circle["x"] = x ? x : 0;
        circle["y"] = y ? y : 0;
        return circle;
    };
    // Draw an ellipse
    TBGraphics.prototype.drawEllipse = function (x, y, rx, ry, fillColor, strokeColor, lineThickness) {
        var ellipse = new PIXI["Graphics"]();
        if (fillColor) {
            ellipse["beginFill"](fillColor);
        }
        if (strokeColor) {
            lineThickness = lineThickness ? lineThickness : 1;
            ellipse["lineStyle"](lineThickness, strokeColor, 1);
        }
        ellipse["drawEllipse"](0, 0, rx, ry);
        ellipse["endFill"]();
        ellipse["x"] = x ? x : 0;
        ellipse["y"] = y ? y : 0;
        return ellipse;
    };
    // Draw a line
    TBGraphics.prototype.drawLine = function (x1, y1, x2, y2, strokeColor, lineThickness) {
        var line = new PIXI["Graphics"]();
        if (strokeColor) {
            lineThickness = lineThickness ? lineThickness : 1;
            line["lineStyle"](lineThickness, strokeColor, 1);
        }
        line["moveTo"](0, 0);
        line["lineTo"](x2, y2);
        line["x"] = x1;
        line["y"] = y1;
        return line;
    };
    // Draw a triangle
    TBGraphics.prototype.drawTriangle = function (x1, y1, x2, y2, x3, y3, fillColor, strokeColor, lineThickness) {
        var triangle = new PIXI["Graphics"]();
        if (fillColor) {
            triangle["beginFill"](fillColor);
        }
        if (strokeColor) {
            lineThickness = lineThickness ? lineThickness : 1;
            triangle["lineStyle"](lineThickness, strokeColor, 1);
        }
        triangle["moveTo"](0, 0);
        triangle["lineTo"](x2, y2);
        triangle["lineTo"](x3, y3);
        triangle["lineTo"](0, 0);
        triangle["endFill"]();
        triangle["x"] = x1;
        triangle["y"] = y1;
        return triangle;
    };
    // Draw a polygon
    TBGraphics.prototype.drawPolygon = function (x, y, fillColor, strokeColor, width) {
    };
    // Draw a polyline
    TBGraphics.prototype.drawPolyLine = function (x, y, strokeColor, width) {
    };
    // Draw a text
    TBGraphics.prototype.drawText = function (text, x, y, fillColor, font, strokeColor, width) {
    };
    // Return the width of a text
    TBGraphics.prototype.textWidth = function (text, font) {
        if (this.webGLAvailable) {
            console.log("Not available in WebGL");
            return;
        }
        this.context.font = font;
        return this.context.measureText(text).width;
    };
    /**
     *
     * @param {tbContainer} referenceObject
     * @param {{x, y}} pointToTransform
     * @returns {tbVector}
     */
    TBGraphics.prototype.toLocal = function (referenceObject, pointToTransform) {
        if (referenceObject instanceof tbContainer) {
            if (referenceObject.container) {
                var pixiPoint = new PIXI["Point"](pointToTransform.x, pointToTransform.y);
                var ret = referenceObject.container["toLocal"](pixiPoint);
                return new tbVector(ret.x, ret.y);
            }
        }
        else {
            console.error("toLocal only available for Containers");
        }
    };
    /**
     *
     * @param {tbContainer} referenceObject
     * @param {{x, y}} pointToTransform
     * @returns {tbVector}
     */
    TBGraphics.prototype.toGlobal = function (referenceObject, pointToTransform) {
        if (referenceObject instanceof tbContainer) {
            if (referenceObject.container) {
                var pixiPoint = new PIXI["Point"](pointToTransform.x, pointToTransform.y);
                var ret = referenceObject.container["toGlobal"](pixiPoint);
                return new tbVector(ret.x, ret.y);
            }
        }
        else if (referenceObject && referenceObject["toGlobal"]) {
            var pixiPoint = new PIXI["Point"](pointToTransform.x, pointToTransform.y);
            var ret = referenceObject["toGlobal"](pixiPoint);
            return new tbVector(ret.x, ret.y);
        }
        else {
            console.error("toLocal only available for Containers");
        }
    };
    return TBGraphics;
}());
// Create the graphics object
export var tbGraphics = new TBGraphics();
